module.exports = __webpack_public_path__ + "img/fridge-01.32cf37cf.png";